// styles.js
import { StyleSheet } from '@react-pdf/renderer';
import * as colors from '../../config/colors';

const styles = StyleSheet.create({
  page: {
    padding: 30,
  },
  header: {
    fontSize: 18,
    marginBottom: 2,
    paddingBottom: 2,
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start', // Alinha os cards à esquerda
    gap: 5, // Espaço entre os cards
    paddingRight: 30, // Espaço extra no lado direito do contêiner
  },
  card: {
    width: '19.3%', // Ajuste a largura conforme necessário
    marginBottom: 2,
    border: '1px solid black',
    padding: 5,
    borderRadius: 10,
  },
  section: {
    marginBottom: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  label: {
    fontSize: 8,
    fontWeight: 'bold',
    flex: 2, // Aumenta o espaço do label
  },
  value: {
    fontSize: 8,
    // flex: 1, // Diminui o espaço do value
    textAlign: 'right', // Alinha os valores à direita
  },
  divider: {
    marginVertical: 5,
    height: 1,
    backgroundColor: 'black',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: '#000',
    borderStyle: 'solid',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    borderBottomStyle: 'solid',
  },
  tableCell: {
    fontSize: 6, // Fonte reduzida para melhor ajuste
    textAlign: 'right',
    padding: 5,
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#000',
    borderRightStyle: 'solid',
  },
  tableCellWide: {
    fontSize: 6, // Fonte menor para tipo de despesa e detalhe
    textAlign: 'right',
    padding: 5,
    flex: 2,
    borderRightWidth: 1,
    borderRightColor: '#000',
    borderRightStyle: 'solid',
  },
  tableHeader: {
    fontWeight: 'bold',
    backgroundColor: colors.primaryColor, // Fundo azul para cabeçalho
    color: '#fff', // Texto branco
    textTransform: 'uppercase', // Caixa alta
    textAlign: 'center',
  },
  totalRow: {
    fontWeight: 'bold',
    backgroundColor: colors.TotalColor, // Fundo amarelo para Total Geral e coluna Total
    color: '#000',
    textTransform: 'uppercase', // Caixa alta para Total Geral
  },
  subtotalRow: {
    fontWeight: 'bold',
    backgroundColor: colors.SubTotalColor, // Fundo verde claro para subtotais
    color: '#000',
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    paddingBottom: 10,
  },
  logo: {
    width: 90,
    height: 50,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    flex: 1,
  },
  date: {
    fontSize: 12,
    textAlign: 'right',
  },
  style1: {
    marginRight: '10px',
  },
  style2: {
    background: 'colors.cardColor4',
  },
  style3: {
    marginBottom: '10px',
    border: '1px solid black',
    // Borda preta
    color: 'black',
    // Fonte preta
    borderRadius: '10px',
    fontFamily: 'sans-serif',
    textDecoration: 'none',
    backgroundColor: 'transparent',
  },
  style4: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  style5: {
    backgroundColor: 'black',
    borderRadius: '10px',
    marginBottom: '10px',
  },
  style6: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  style7: {
    marginBottom: '10px',
    border: '1px solid black',
    // Borda preta
    color: 'black',
    // Fonte preta
    borderRadius: '10px',
    fontFamily: 'sans-serif',
    textDecoration: 'none',
    backgroundColor: 'transparent',
  },
  style8: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  style9: {
    backgroundColor: 'black',
    borderRadius: '10px',
    marginBottom: '10px',
  },
  style10: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  style11: {
    marginRight: '10px',
  },
  gridContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  column: {
    width: '32%', // 3 colunas com um pequeno espaçamento
  },
  columnItem: {
    padding: 0, // Remover padding
    margin: 0, // Remover margem
    textAlign: 'left',
    lineHeight: 1.2, // Ajustar o espaçamento entre as linhas
  },
  gridItem: {
    width: '33.33%', // 3 colunas
    padding: 5,
    textAlign: 'center',
  },
  columnContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginTop: 10,
  },
});

export default styles;
